import React, { useCallback, useState } from 'react';
import { Modal, Button, Alert, Row } from 'antd';
import PropTypes from 'prop-types';
import Input from '../elements/input/Input';
import { createClinic } from '../../api/medics-api';
import { toast } from 'react-toastify';

const CreateClinicModal = ({ isOpen, onClose, onCreate }) => {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const [modalForm, setModalForm] = useState({
    name: '',
    email: '',
    password: '',
    phone: '',
  });
  const [modalFormErrors, setModalFormErrors] = useState({
    name: false,
    email: false,
    password: false,
  });

  const handleResetForm = () => {
    setModalForm({
      name: '',
      email: '',
      password: '',
      phone: '',
    });
    setModalFormErrors({
      name: false,
      email: false,
      password: false,
    });
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;

    setModalForm((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const validateInputs = () => {
    const { name, email, password } = modalForm;
    if (!name.trim()) {
      setError('Unesite naziv organizacije.');
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Unesite validnu adresu e-pošte.');
      return false;
    }
    // password to contain at least one uppercase, one lowercase, one number and one special character
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!$%_.,#+])[A-Za-z\d!$%_.,#+]{8,}$/;
    if (!passwordRegex.test(password)) {
      setError(
        'Lozinka mora sadržati najmanje 8 karaktera, uključujući veliko i malo slovo, broj i specijalni karakter (!$%_.,#+).'
      );
      return false;
    }
    setError('');
    return true;
  };

  const handleOk = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const validate = validateInputs();

      if (!validate) {
        // toast.error('Some fields are invalid. Please check your form!');
        setLoading(false);
        return;
      }

      const values = {
        ...modalForm,
        firstName: 'ime',
        lastName: 'prezime',
        isActive: true,
      };

      toast.loading('Kreiranje organizacije...');

      const { success, message } = await createClinic(values);

      if (!success) {
        toast.dismiss();
        setError(message);
        throw new Error(message);
      }

      toast.dismiss();
      toast.success('Organizacija uspešno kreirana!');
      onCreate();
      onClose();
      setModalForm({
        name: '',
        email: '',
        password: '',
        phone: '',
      });

      setTimeout(() => {
        toast.dismiss();
        toast.success('Organizacija uspešno kreirana!');
        setLoading(false);
      }, 1000);
    } catch (error) {
      if (error?.errorFields) return;

      toast.error(`Error creating clinic: ${error}`);
      setError(
        error.message || 'Došlo je do greške pri kreiranju organizacije.'
      );
    } finally {
      setLoading(false);
    }
  }, [modalForm]);

  const handleCancel = () => {
    handleResetForm();
    setError('');
    onClose();
  };

  return (
    <Modal
      className={'create_user_modal'}
      title="Dodaj organizaciju"
      open={isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button
          key="create"
          type="primary"
          onClick={handleOk}
          className="btn-primary"
          disabled={loading || done}
        >
          {loading ? (
            <img
              src="/assets/icons/add.svg"
              alt="Add Icon"
              className="animate-spin"
            />
          ) : done ? (
            <img
              src="/assets/icons/check.svg"
              alt="Check Icon"
              className="check-icon"
            />
          ) : (
            'Dodaj organizaciju'
          )}
        </Button>,
      ]}
    >
      <form
        className={'create_user_modal_form'}
        layout="vertical"
        autoComplete="off"
      >
        <Row className={'create_user_modal_row'}>
          {/* <div>
            <Input
              label="Ime vlasnika"
              id="firstName"
              name="firstName"
              placeholder="Ime Vlasnika"
              value={modalForm.firstName}
              onChange={(e) => handleOnChange(e)}
            />
          </div> */}

          {/* <div>
            <Input
              label="Prezime Vlasnika"
              id="lastName"
              name="lastName"
              placeholder="Prezime Vlasnika"
              value={modalForm.lastName}
              onChange={(e) => handleOnChange(e)}
            />
          </div> */}

          <div>
            <Input
              label="Naziv organizacije"
              id="name"
              name="name"
              placeholder="Naziv organizacije"
              value={modalForm.name}
              onChange={(e) => handleOnChange(e)}
            />
          </div>

          <div>
            <Input
              type="email"
              required
              autoComplete="new-email"
              label="Adresa e-poste"
              id="email"
              name="email"
              placeholder="Adresa e-poste"
              value={modalForm.email}
              onChange={(e) => handleOnChange(e)}
            />
          </div>

          <div>
            <Input
                label="Broj telefona"
                id="phone"
                name="phone"
                placeholder="+381646668372"
                value={modalForm.phone}
                onChange={(e) => handleOnChange(e)}
            />
          </div>

          <div>
            <Input
              type="password"
              label="Lozinka"
              id="password"
              name="password"
              placeholder="Lozinka"
              value={modalForm.password}
              onChange={(e) => handleOnChange(e)}
            />
          </div>
        </Row>

        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}
      </form>
    </Modal>
  );
};

CreateClinicModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
};

export default CreateClinicModal;
